import type { ListBuilderList } from '../../../types';
import { AGING_REQUIRED_FIELDS, BASE_FILTER_RULES } from '../shared';

/**
 * Past due invoices - all outstanding invoices where due date has passed
 */
export const pastDueInvoicesList: ListBuilderList = {
	id: 'default-invoices-past-due',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Past Due',
	type: 'default',
	active: true,
	sortOrder: 1,
	description: 'All outstanding invoices past their due date',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'past-due',
					label: 'Past Due',
					data: {
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all past-due invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
};
